import React from 'react';

import wrapStore from '@src/utils/wrap-store';
import OrientationStore from '@src/components/orientation/store';
import { isAndroid } from 'detect-mobile-device';



const styles = require('./index.less');
/**
 * Orientation
 * @param store {OrientationStore}
 * @returns {JSX.Element|null}
 * @constructor
 */
const Orientation = ({ store }) => {
  store.use();
  /**
   * 渲染遮罩层中的内容 (使用 JSX)
   */
  const renderMaskContent = () => {
    // 否则使用默认的 promptImg
    console.log(store.LocalesData,'store');
    if (store?.LocalesData) {
      return (
        <div className={styles.promptImgBox}>
          <img className={styles.promptImg} src={require('./images/FOWfu8.png')} alt="Orientation Prompt" />;
          <div className={styles.promptDesc}>{store?.LocalesData.cookieInfo.orientation_text}</div>
          {renderBtn()}
        </div>
      );
    }

  };
  const renderBtn = () => {
    const isiPad = navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isiPadPro = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
    const isHuaweiPad = () => {
      const isHuawei = /huawei|huaweipad|matepad/.test(navigator.userAgent);
      const isTablet = /(ipad|tablet|huaweipad|matepad)/i.test(navigator.userAgent) || (window.innerWidth >= 768 && window.innerHeight >= 1024);
      return isAndroid() && isHuawei && isTablet;
    };
    // if (isiPad || isiPadPro || isHuaweiPad()) {
    // return <div className={styles.btn} onClick={store.hideOrientation} />;
    if (store?.LocalesData) {
      return (
        <button className="parallelogram-btn" onClick={store.hideOrientation}>
          <span>{store?.LocalesData.cookieInfo.orientation_btn_text}</span>
        </button>
      );
    }

    // }
  };
  if (!store.isShow) {
    return null;
  }
  return <div className={styles.orientationMask}>{renderMaskContent()}</div>;
};

export default wrapStore(Orientation, OrientationStore);
